import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/lib/components/Select";
import { cn } from "@/lib/utils";
import { CaptionAnimationDto, CaptionDisplayMode } from "@repo/api/caption";

const ANIMATION_LABELS: Record<"NONE" | CaptionAnimationDto["type"], string> = {
  NONE: "No animation",
  FADE_IN: "Fade in",
  POP_IN: "Pop in",
};

const ANIMATIONS_BY_DISPLAY_MODE: Record<
  CaptionDisplayMode,
  ("NONE" | CaptionAnimationDto["type"])[]
> = {
  STATIC: ["NONE", "FADE_IN", "POP_IN"],
  HIGHLIGHTED: ["NONE", "FADE_IN"],
  SINGLE_WORD: ["NONE", "FADE_IN", "POP_IN"],
};

type AnimationSelectProps = {
  displayMode: CaptionDisplayMode;
  animation: "NONE" | CaptionAnimationDto["type"];
  onAnimationChange: (value: "NONE" | CaptionAnimationDto["type"]) => void;
};

export function AnimationSelect({
  displayMode,
  animation,
  onAnimationChange,
}: AnimationSelectProps) {
  const animationOptions = ANIMATIONS_BY_DISPLAY_MODE[displayMode].map(
    (value) => ({
      label: ANIMATION_LABELS[value],
      value,
    }),
  );

  const effectiveAnimation = ANIMATIONS_BY_DISPLAY_MODE[displayMode].includes(
    animation,
  )
    ? animation
    : "NONE";

  return (
    <Select value={effectiveAnimation} onValueChange={onAnimationChange}>
      <SelectTrigger
        className={cn(
          "h-9 w-50",
          effectiveAnimation === "NONE" && "text-text-secondary",
        )}
      >
        <SelectValue>
          {animationOptions.find((o) => o.value === effectiveAnimation)
            ?.label ?? "No Animation"}
        </SelectValue>
      </SelectTrigger>
      <SelectContent>
        {animationOptions.map((option) => (
          <SelectItem key={option.value} value={option.value}>
            {option.label}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
